import React from 'react'
import tw from 'tailwind-styled-components'

const TwThead = tw.thead`
  bg-main-old 
  text-third-old
  text-12
  border-0
  sticky
  top-0
`

export interface Props {
  children?: React.ReactNode
}

export const Header = (props: Props) => {
  const {children} = props
  return (
    <TwThead>
      <tr>{children}</tr>
    </TwThead>
  )
}
